/* Progressive enhancement. All products, prices and links are rendered by Shopify. */
(()=>{
  'use strict';
  function init(root){
    if(root.dataset.mailegReady)return;
    root.dataset.mailegReady='true';
    const all=s=>Array.from(root.querySelectorAll(s));
    const status=root.querySelector('[data-maileg-status]');
    const announce=t=>{if(status)status.textContent=t;};
    function select(kind,id){
      all('[data-'+kind+']').forEach(b=>b.setAttribute('aria-pressed',b.dataset[kind]===id?'true':'false'));
      all('[data-'+kind+'-panel]').forEach(p=>{p.hidden=p.getAttribute('data-'+kind+'-panel')!==id;});
    }
    all('[data-world]').forEach(b=>b.addEventListener('click',()=>{
      select('world',b.dataset.world);
      announce('Univers sélectionné : '+b.textContent.trim());
      const panel=all('[data-world-panel]').find(p=>p.dataset.worldPanel===b.dataset.world);
      if(panel)panel.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }));
    all('[data-scene]').forEach(b=>b.addEventListener('click',()=>{
      select('scene',b.dataset.scene);announce(b.getAttribute('aria-label'));
      if(window.matchMedia('(max-width:600px)').matches){
        const panel=all('[data-scene-panel]').find(p=>p.dataset.scenePanel===b.dataset.scene);
        if(panel){const r=panel.getBoundingClientRect();if(r.bottom>window.innerHeight||r.top<100)panel.scrollIntoView({block:'nearest',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});}
      }
    }));
    all('[data-select-scene]').forEach(b=>b.addEventListener('click',()=>select('scene',b.dataset.selectScene)));
    all('[data-starter]').forEach(b=>b.addEventListener('click',()=>{select('starter',b.dataset.starter);announce('Première histoire : '+b.textContent.trim());}));
    // Editorial assignments by exact product handle; never infer a room from broad tags.
    const roomsByHandle={
      "tente-happy-camper-souris-maileg":["jardin"],
      "boite-a-pain-et-ses-accessoires-maileg":["cuisine"],
      "machine-a-laver-en-metal-maileg":["buanderie"],
      "jouets-de-plage-pour-poupees-maileg":["jardin"],
      "canape-miniature-deux-places-a-carreaux-maileg":["salon"],
      "table-et-fer-a-repasser-pour-souris-maileg":["buanderie"],
      "feu-de-camp-miniature-et-accessoires-maileg":["jardin"],

      'chariot-pour-tricycle-corail-maileg':['jardin'],
      'chariot-pour-tricycle-vert-maileg':['jardin'],
      'chariot-pour-tricycle-rouge-maileg':['jardin'],
      'trottinette-miniature-orange-maileg':['jardin'],
      'trotinette-souris-bleu-maileg':['jardin'],
      'table-et-tabouret-en-bois-maileg-maileg':['cuisine'],
      'petit-tapis-miniature-a-fleurs-maileg':['salon','chambre'],
      'chaise-vintage-dark-powder-maileg':['cuisine','salon'],
      'aspirateur-miniature-maileg':['buanderie','salon'],
      'fauteuil-pour-souris-a-pois-maileg':['salon'],
      'fauteuil-pour-souris-fleuri-maileg':['salon'],
      'rocking-chair-pour-souris-sable-chaud-maileg':['salon','bebe'],
      'service-a-soupe-pour-souris-maileg':['cuisine'],
      'coffret-gaufrier-pour-souris-maileg':['cuisine'],
      'coffret-bain-pour-souris-jaune-maileg':['bain'],
      'pick-up-pour-souris-maileg':['jardin'],
      'luge-pour-souris-maileg':['jardin'],
      'coffret-cuisine-miniature-madam-blue-maileg':['cuisine'],
      'balai-et-pelle-miniatures-maileg':['buanderie'],
      'chaise-miniature-decolier-jaune-maileg':['cuisine','chambre'],
      'voiture-pour-souris-sable-chaud-maileg':['jardin'],
      'grande-table-manger-souris-maileg':['cuisine'],
      'lit-superpose-pour-souris-sable-chaud-maileg':['chambre'],
      'comptoir-cuisine-souris-maileg':['cuisine'],
      'lavabo-pour-souris-blanc-casse-maileg':['bain'],
      'carrosse-citrouille-pour-souris-maileg':['jardin'],
      'petits-fours-et-presentoir-miniature-rose-maileg':['cuisine'],
      'boite-cuisine-et-accessoires-pour-souris-maileg':['cuisine'],
      'table-et-fer-a-repasser-bleu-maileg':['buanderie'],
      'chaise-miniature-en-metal-or-maileg-maileg':['cuisine','salon'],
      'tricycle-rouge-souris-maileg':['jardin'],
      'trousse-de-toilette-pour-souris-rouge-maileg':['bain'],
      'gateau-de-fete-et-son-presentoir-micro-maileg':['cuisine'],
      'tenue-de-clown-pour-souris-maileg':['chambre'],
      'berceau-micro-rose-maileg':['bebe'],
      'berceau-micro-menthe-maileg':['bebe'],
      'fauteuil-rose-souris-maileg':['salon'],
      'tablebasse-maileg-bois-souris':['salon'],
      'plante-fleurs-maileg':['salon','jardin'],
      'arrosoir-miniature-bleu-maileg':['jardin'],
      'lit-bebe-micro-maileg-rose':['bebe'],
      'ensemble-de-peche-pour-souris-maileg':['jardin'],
      'rocking-chair-rose-maileg':['salon','bebe'],
      'chevalabascule-maileg':['chambre','bebe'],
      'television-souris-maileg':['salon'],
      'poussette-miniature-jaune-maileg':['bebe','jardin'],
      'reveil-rose-miniature-maileg':['chambre']
    };
    const cards=all('[data-maileg-card]');let category='tout',room='tout',limit=12;
    // Keep explicit price/date/best-selling sorts intact. In our editorial view,
    // show purchasable pieces first, then announced arrivals, then sold-out pieces.
    const sortChoice=root.querySelector('.catalog-tools select');
    const catalogGrid=root.querySelector('[data-catalog-grid]');
    if(catalogGrid&&sortChoice?.value==='manual'){
      const priority=card=>card.dataset.available==='true'?0:card.dataset.comingSoon==='true'?1:2;
      cards.sort((a,b)=>priority(a)-priority(b));
      cards.forEach(card=>catalogGrid.appendChild(card));
    }
    // Exact editorial families avoid classifying a mouse-patterned tin as a character.
    const familiesByHandle={
      "tente-happy-camper-souris-maileg":"mobilier",
      "boite-a-pain-et-ses-accessoires-maileg":"mobilier",
      "machine-a-laver-en-metal-maileg":"mobilier",
      "jouets-de-plage-pour-poupees-maileg":"mobilier",
      "canape-miniature-deux-places-a-carreaux-maileg":"mobilier",
      "table-et-fer-a-repasser-pour-souris-maileg":"mobilier",
      "feu-de-camp-miniature-et-accessoires-maileg":"mobilier",
      "maman-souris-ski-maileg-maileg":"souris",
      "peluche-rhinoceros-gris-medium-maileg":"peluches",

      'souris-grand-frere-prince-vichy-maileg':'souris',
      'decoration-sucre-dorge-en-metal-a-pois-maileg':'deco',
      'grand-sucre-dorge-en-metal-a-pois-maileg':'deco',
      'bretzel-en-metal-a-pois-maileg':'deco',
      'ange-en-metal-etoile-maileg':'deco',
      'oiseau-en-metal-blanc-casse-et-or-maileg':'deco',
      'oiseau-en-metal-a-pois-verts-maileg':'deco',
      'duo-de-boites-santa-is-coming-maileg':'deco',
      'porte-de-noel-pour-souris-maileg':'deco',
      'boite-coulissante-blossom-heather-maileg':'deco',
      'boite-en-metal-coulissante-blossom-ocre-maileg':'deco',
      'boite-coulissante-souris-maileg':'deco',
      'boite-coulissante-blossom-bleu-maileg':'deco',
      'boite-coulissante-blossom-heather-fleurs-maileg':'deco',
      'duo-de-boites-fleuries-ocre-et-bleu-maileg':'deco',
      'boite-en-metal-branches-maileg':'deco',
      'theatre-pour-souris-maileg':'mobilier',
      'princesse-au-petit-pois-souris-maileg':'souris',
      'triples-bebes-souris-en-boite-vichy-maileg':'souris',
      'renne-maman-maileg':'peluches',
      'renard-petit-frere-maileg':'peluches',
      'renard-grand-frere-maileg':'peluches'
    };
    const roomsFor=card=>roomsByHandle[card.dataset.handle]||[];
    const roomFilters=root.querySelector('[data-maileg-rooms]');
    const more=root.querySelector('[data-show-more]'),count=root.querySelector('[data-catalog-count]');
    function matches(card,cat){
      const t=card.dataset.search;
      if(cat==='tout')return true;
      if(cat==='dispo')return card.dataset.available==='true';
      if(cat==='bientot')return card.dataset.comingSoon==='true';
      const family=familiesByHandle[card.dataset.handle];
      if(cat==='deco')return family==='deco';
      if(family==='deco')return false;
      if(cat==='lapins')return /lapin|bunny|rabbit/.test(t);
      if(cat==='oursons')return /ourson|teddy|ours en peluche/.test(t);
      if(cat==='peluches')return family?family==='peluches':/peluche|lapin|bunny|rabbit|teddy|ourson|hippopotame|éléphant|elephant|faon|cerf|chaton/.test(t);
      if(cat==='danse')return /ballerine|ballet|danseur|danseuse|reine|roi |princesse|carrosse|fée|clown/.test(t);
      if(cat==='souris'){
        if(family)return family==='souris';
        // Classify the character named in the title, not accessory tags such as "souris".
        const title=(card.querySelector('h3')?.textContent||'').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/œ/g,'oe').trim();
        return /^(?:souris\b|(?:bebes?|jumeaux|couple de|papa|maman|mamie|papi|grand[ -]pere|grand[ -]mere|petit frere|petite soeur|grand frere|grande soeur|reine maman|roi papa)\s+souris\b)/.test(title);
      }
      if(cat==='mobilier')return roomsFor(card).length>0||(!matches(card,'peluches')&&!matches(card,'souris'));
      return true;
    }
    function render(){
      let matched=0,shown=0;
      cards.forEach(card=>{const assigned=roomsFor(card);const roomMatches=category!=='mobilier'||room==='tout'||(room==='autres'?assigned.length===0:assigned.includes(room));const ok=matches(card,category)&&roomMatches;if(ok)matched++;const visible=ok&&shown<limit;card.hidden=!visible;if(visible)shown++;});
      if(more)more.hidden=shown>=matched;
      if(count)count.textContent=matched===0?'Aucun trésor dans cette sélection pour le moment.':shown+' trésors affichés sur '+matched;
      all('[data-filter]').forEach(b=>b.setAttribute('aria-pressed',b.dataset.filter===category?'true':'false'));
      if(roomFilters)roomFilters.hidden=category!=='mobilier';
      all('[data-room]').forEach(b=>{
        b.setAttribute('aria-pressed',b.dataset.room===room?'true':'false');
        const code=b.dataset.room;
        b.hidden=code!=='tout'&&!cards.some(card=>matches(card,'mobilier')&&(code==='autres'?roomsFor(card).length===0:roomsFor(card).includes(code)));
      });
    }
    const filters=root.querySelector('[data-maileg-filters]');if(filters)filters.hidden=false;
    all('[data-filter]').forEach(b=>b.addEventListener('click',()=>{category=b.dataset.filter;room='tout';limit=12;render();}));
    all('[data-character-filter]').forEach(a=>a.addEventListener('click',()=>{category=a.dataset.characterFilter;room='tout';limit=12;render();}));
    all('[data-room]').forEach(b=>b.addEventListener('click',()=>{room=b.dataset.room;limit=12;render();announce('Pièce sélectionnée : '+b.textContent.trim()+'. '+(count?count.textContent:''));}));
    if(more)more.addEventListener('click',()=>{limit+=12;render();});
    render();
    root.addEventListener('shopify:block:select',event=>{
      const block=event.target.closest('[data-world],[data-scene],[data-starter]');if(!block)return;
      ['world','scene','starter'].forEach(kind=>{if(block.dataset[kind])select(kind,block.dataset[kind]);});
    });
  }
  document.querySelectorAll('[data-maileg-worlds]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-maileg-worlds]').forEach(init));
})();
